export const cookieNames = ['mobileApp', 'mobileAppMode', 'mobileAppVersion'];
